
import { Box, Card, Grid, Typography } from "@mui/material";
import React from "react";
import { styles } from "../styles/styles";
import { DecorativeCorner } from "../common/DecorativeCorner";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import ChatIcon from "@mui/icons-material/Chat";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

function HowItWorks() {
	return (
		<div>
			<Card
				sx={{
					...styles.whyuse,
					height: "auto",
					padding: { xs: 2, sm: 3, md: 4 },
				}}
			>
				<DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
				<DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
				<DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
				<DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />

				<Typography variant="h4" component="h1" sx={styles.heading}>
					How it Works?
				</Typography>

				<Grid
					container
					spacing={3}
					alignItems="center"
					justifyContent="center"
					sx={{ padding: { xs: 1, sm: 2 } }}
				>
					<Grid
						item
						xs={12}
						sm={6}
						md={2}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							textAlign: "center",
						}}
					>
						<Box sx={styles.processCard}>
							<PersonAddIcon
								sx={{
									...styles.iconStyles,
									fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
								}}
							/>
							<Typography
								sx={{
									...styles.processText,
									fontSize: { xs: "14px", sm: "16px", md: "18px" },
								}}
							>
								Profile Creation
							</Typography>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={6}
						md={1}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%", 
							transform: { xs: "rotate(90deg)", sm: "rotate(0deg)" },
						}}
					>
						<ArrowRightAltIcon
							sx={{
								...styles.processArrow,
								fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
							}}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={2}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							textAlign: "center",
						}}>
						<Box sx={styles.processCard}>
							<ConnectWithoutContactIcon
								sx={{
									...styles.iconStyles,
									fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
								}}
							/>
							<Typography
								sx={{
									...styles.processText,
									fontSize: { xs: "14px", sm: "16px", md: "18px" },
								}}
							>
								Connection
							</Typography>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={6}
						md={1}
						sx={{
							display: "flex",
							justifyContent: "center", 
							alignItems: "center", 
							height: "100%",
							transform: { xs: "rotate(90deg)", sm: "rotate(0deg)" },
						}}
					>
						<ArrowRightAltIcon
							sx={{
								...styles.processArrow,
								fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
							}}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={2}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							textAlign: "center",
						}}>
						<Box sx={styles.processCard}>
							<ChatIcon
								sx={{
									...styles.iconStyles,
									fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
								}}
							/>
							<Typography
								sx={{
									...styles.processText,
									fontSize: { xs: "14px", sm: "16px", md: "18px" },
								}}
							>
								Intimate Communication
							</Typography>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={6}
						md={1}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
							transform: { xs: "rotate(90deg)", sm: "rotate(0deg)" },
						}}
					>
						<ArrowRightAltIcon
							sx={{
								...styles.processArrow,
								fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
							}}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={2}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							textAlign: "center",
						}}>
						<Box sx={styles.processCard}>
							<CalendarMonthIcon
								sx={{
									...styles.iconStyles,
									fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
								}}
							/>
							<Typography
								sx={{
									...styles.processText,
									fontSize: { xs: "14px", sm: "16px", md: "18px" },
								}}
							>
								Arranging Meetings
							</Typography>
						</Box>
					</Grid>
				</Grid>
			</Card>
		</div>
	);
}

export default HowItWorks;